// ============================================================
// DialogueBox.tsx
// Small form dialog shell (close / rename / assign case, duplicate, email
// change, timer-leave, export PDF). API unchanged: isOpen, title, onClose,
// children — each caller's form renders in the body as before.
//
// Now built on the shared ModalFrame (size sm = max-w-md, the old width):
// green hero band with the title (not uppercase) + ✕, body padding
// px-6 sm:px-8 py-6. ModalFrame supplies Esc (top-most only), backdrop
// press+release, focus trap + restore. z-[90] so it stacks above any
// ModalFrame modal it's opened from.
//
// The DIALOG_* class strings below are the light-pass styles for the
// forms inside (labels / fields), matching NewCaseModal's form language.
// ============================================================
import React from 'react'
import ModalFrame from './ModalFrame'

interface DialogueBoxProps {
  isOpen: boolean
  title: string
  onClose: () => void
  children: React.ReactNode
}

// NewCaseModal.tsx:54-60 — .f label + the field.
export const DIALOG_LABEL = 'block text-[12px] font-semibold text-casevo-forest mb-[5px]'
export const DIALOG_FIELD =
  'w-full border border-casevo-border rounded-lg px-3 py-2.5 text-sm bg-casevo-input dark:bg-[#1f2e26] text-casevo-forest ' +
  'placeholder:text-casevo-text-soft focus:outline-none focus:border-casevo-mid ' +
  'focus:shadow-[0_0_0_3px_color-mix(in_srgb,var(--casevo-mid)_18%,transparent)]'

const DialogueBox: React.FC<DialogueBoxProps> = ({ isOpen, title, onClose, children }) => (
  <ModalFrame isOpen={isOpen} onClose={onClose} size="sm" zIndexClassName="z-[90]" title={title}>
    {children}
  </ModalFrame>
)
export default DialogueBox
